// extracted by mini-css-extract-plugin
module.exports = {"root":"_60ae0e"};